module.exports = __webpack_public_path__ + "static/img/compleet-persoprofiler.0bb8f90c.svg";